import {Component, HostListener, OnInit} from '@angular/core';
import {EventService} from "../../services/event.service";
import { DatePipe } from '@angular/common';
import {environment} from "../../../../environments/environment";
import {SessionLoginService} from "../../../core/services/session-login.service";
import {TranslationService} from "../../services/translation.service";
import {CategoryDialogComponent} from "../admin/category-dialog/category-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {MatDialog} from "@angular/material/dialog";
import {EventFormComponent} from "../event-form/event-form.component";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit {
  zoomScale = 1;

  events: any[] = [];
  errorMessage: string = '';
  breakpoint: any;
  gutterSize: any;
  rowHeight: any;
  column: any;
  isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);

  isLoading: boolean = false;
  currentEvent: any = null;
  constructor(
    public translate: TranslateService,
    public dialog: MatDialog,
    public translationService: TranslationService,
    private eventService: EventService,
    private datePipe: DatePipe,
    public session: SessionLoginService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute
  ) {
  }

  isFullscreen = false;
  currentImage: string = '';

  imageWidth: number = 0;
  imageHeight: number = 0;

  openFullscreen(imageUrl: any) {
    if(!imageUrl) {
      return;
    }
    this.isFullscreen = true;
    this.currentImage = imageUrl;
    this.adjustImageSize();
  }

  adjustImageSize() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const image = new Image();
    image.src = this.currentImage;

    image.onload = () => {
      const imageAspectRatio = image.width / image.height;
      const screenAspectRatio = screenWidth / screenHeight;

      if (imageAspectRatio > screenAspectRatio) {

        this.imageWidth = screenWidth;
        this.imageHeight = (screenWidth / imageAspectRatio);
      } else {

        this.imageHeight = screenHeight;
        this.imageWidth = (screenHeight * imageAspectRatio);
      }
    };

    image.onerror = () => {
      console.error('Erreur de chargement de l\'image');
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustImageSize();
  }

  closeFullscreen() {
    this.isFullscreen = false;
  }

  ngOnInit(): void {
    let lang = localStorage.getItem('selectedLanguage');
    if(lang) {
      this.translate.use(lang);
    }

    this.setBackgroundImage();

    this.loadEvents();

  }


  loadEvents(): void {
    const eventId = this.route.snapshot.paramMap.get('id'); // Récupérer l'ID à partir de l'URL


    if (eventId) {
      // Si un ID est passé dans l'URL, récupérer cet événement spécifique
      this.isLoading = true;
      this.eventService.getEvent(eventId).subscribe(
        (data) => {
          this.isLoading = false;
          this.currentEvent = data;
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = 'Erreur lors de la récupération de l\'événement.';
        }
      );
    } else {
      // Sinon, récupérer tous les événements
      this.isLoading = true;
      this.eventService.getEvents().subscribe(
        (data) => {
          this.isLoading = false;
          this.events = data;
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = 'Erreur lors de la récupération des événements.';
        }
      );
    }
  }

  formatEventDate(eventDate: string): any {
    const formattedDate = this.datePipe.transform(eventDate, 'dd/MM/yyyy');

    return formattedDate;
  }

  private setBackgroundImage() {

    this.column = 'col-lg-4';
    if(window.innerHeight > window.innerWidth){
      this.column = 'col-lg-6';
    }

    this.rowHeight = (window.innerWidth < 1023) ? '220px' : '200px';

    let background = 'assets/' + environment.client + '/background/home/h.jpg';
    if(window.innerHeight > window.innerWidth){
      background = 'assets/' + environment.client + '/background/home/v.jpg';
    }

    var myCss = ".mat-drawer-container { background:url('" + background + "') no-repeat center center fixed;}";
    var style = document.createElement("STYLE");
    style.innerText = myCss;
    document.body.appendChild(style);
  }

  openCategoryDialogDialog(id = null): void {
    const dialogRef = this.dialog.open(EventFormComponent, {
      width: this.isMobile ? '100vw' : '800px',

      maxWidth: '100vw',
      panelClass: this.isMobile ? 'full-screen-dialog' : '',
      data: { id }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadEvents();
      }
    });
  }

}
